"use client";

import React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
export default function KindWords() {
  const testimonials = [{
    author: "Sarah Jenkins",
    quote: "The focaccia deli sandwiches are a revelation. The bread is perfectly salted and the imported meats are top-tier."
  }, {
    author: "Mark Thompson",
    quote: "A hidden gem in Enfield. Their matcha is whisked to perfection and the European market selection is unmatched."
  }, {
    author: "Elena Rossi",
    quote: "Warm atmosphere and the best breakfast sandwiches in town. It feels like a little piece of Europe right here."
  }];
  return <section data-section-id="221909" id="kind-words" className="bg-background py-24 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-secondary/10 blur-[100px] rounded-lg pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-7xl relative z-10">
        {}
        <div className="flex flex-col items-center text-center mb-16 md:mb-24">
          <div className="flex gap-1.5 mb-6 text-secondary">
            {[...Array(5)].map((_, i) => <Star key={i} className="size-6 md:size-8 fill-current" />)}
          </div>
          <h2 className="text-7xl md:text-9xl font-default font-semibold tracking-tighter text-foreground mb-6">
            4.9
            <span className="text-4xl md:text-6xl text-muted-foreground font-light tracking-normal ml-1">
              /5
            </span>
          </h2>
          <div className="max-w-md space-y-2">
            <p className="text-foreground font-default font-medium text-lg tracking-wide uppercase">
              Based on 150+ Local Reviews
            </p>
            <p className="text-muted-foreground text-sm font-default leading-relaxed">
              Our community loves the artisanal quality of our café offerings and the 
              authentic flavors of our imported European market goods.
            </p>
          </div>
        </div>

        {}
        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4 md:-ml-6">
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                <Card className="h-full border border-border shadow-sm bg-card/50 hover:bg-accent transition-colors duration-400 rounded-lg">
                  <CardContent className="p-8 md:p-10 flex flex-col justify-between h-full gap-8">
                    <p className="font-serif italic text-2xl md:text-3xl text-foreground leading-snug">
                      "{testimonial.quote}"
                    </p>
                    <div className="flex items-center gap-4 pt-6 border-t border-border/60 mt-auto">
                      <div className="size-10 rounded-lg bg-secondary/20 flex items-center justify-center text-secondary font-default font-semibold text-sm">
                        {testimonial.author.charAt(0)}
                      </div>
                      <div className="font-default font-medium text-sm text-foreground tracking-widest uppercase">
                        {testimonial.author}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex items-center justify-center gap-4 mt-12 md:mt-16">
            <CarouselPrevious className="relative inset-0 translate-y-0 size-12 rounded-lg border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all shadow-sm" />
            <CarouselNext className="relative inset-0 translate-y-0 size-12 rounded-lg border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all shadow-sm" />
          </div>
        </Carousel>
      </div>
    </section>;
}